import { render } from "./TextBox.vue?vue&type=template&id=b80bd532"
import script from "./TextBox.vue?vue&type=script&lang=js"
export * from "./TextBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__